
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider } from '@mui/material';
import { themeParams, useSignal } from '@tma.js/sdk-react';
import { App } from 'components/App';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { useApolloClient } from '../client/apollo';
import { createMuiTheme } from '../theme';

function ErrorBoundaryError({ error }: { error: unknown }) {
  return (
    <div>
      <p>An unhandled error occurred:</p>
      <blockquote>
        <code>
          {error instanceof Error
            ? error.message
            : typeof error === 'string'
              ? error
              : JSON.stringify(error)}
        </code>
      </blockquote>
    </div>
  );
}

export function Root() {
  const { client } = useApolloClient();
  const tp = useSignal(themeParams.state);
  const theme = createMuiTheme(tp);

  if (!client)
    return <></>;
  
  return (
    <ErrorBoundary fallback={ErrorBoundaryError}>
      <ApolloProvider client={client}>
        <ThemeProvider theme={theme}>
          <App/>
        </ThemeProvider>
      </ApolloProvider>
    </ErrorBoundary>
  );
}
